import React, { Component } from "react";
import { findIndex } from "lodash";
import { Button, Modal } from "react-bootstrap";
import { TEXT_CLOSE, CHARM_TYPE } from "../../const";
import DesignTool from "../../designtool";

export default class DialogMessage extends Component {
  handleClose() {
    let {
      designInfo,
      tmpDesignInfo,
      handleCloseDialog,
      tmpListItem,
      tmpRingIdActive,
      isKeepData,
      productList
    } = this.props;
    let itemsAction = DesignTool.getItems();

    // if (tmpDesignInfo.ringId !== 0 && isKeepData) {
    // if (designInfo.ringId !== 0) {
    //   DesignTool.clearItems();
    //   for (var i = 0; i < itemsAction.length; i++) {
    //     let index = findIndex(
    //         productList,
    //         item => item.id === itemsAction[i].productID
    //     );
    //     let hookPos = null;
    //
    //     if (index !== -1 && itemsAction[i].productType === CHARM_TYPE) {
    //       hookPos = {
    //         hookW: productList[index].charm_hanger_width,
    //         hookX: productList[index].charm_hanger_coord_x,
    //         hookY: productList[index].charm_hanger_coord_y
    //       };
    //     }
    //
    //     DesignTool.addItem(
    //         tmpRingIdActive,
    //         itemsAction[i].angle,
    //         itemsAction[i].sizeID,
    //         itemsAction[i].imageURL,
    //         itemsAction[i].imageSize,
    //         itemsAction[i].size,
    //         itemsAction[i].productID,
    //         itemsAction[i].productType,
    //         hookPos
    //     );
    //   }
    // }

    handleCloseDialog("isShowDialogMessage");
  }

  render() {
    let { isShowDialogMessage, dialogMessage, handleCloseDialog } = this.props;

    return (
      <Modal
        show={isShowDialogMessage}
        onHide={() =>  handleCloseDialog("isShowDialogMessage")}
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="dialog_custom"
            centered
      >
        <Modal.Body>
          <span>{dialogMessage}</span>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseDialog("isShowDialogMessage")}>
            {TEXT_CLOSE}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
